import { lazy } from 'react';
import { ROUTES } from 'src/config/routes';
import { AuthRouteProps, RoutesProps } from '@typings/routes';
import { useAuthContext } from '@contexts/auth.context';
import { Navigate } from 'react-router-dom';
import { StorageManager } from '@storage/index';
import { User, UserType } from '@models/User';

const DefaultLayout = lazy(() =>
	import('@components/DefaultLayout').then(module => ({ default: module.DefaultLayout })),
);
const Login = lazy(() => import('@pages/Login').then(module => ({ default: module.Login })));
const LoginSSO = lazy(() => import('@pages/LoginSSO').then(module => ({ default: module.LoginSSO })));

const NoAuthRoute = ({ children, hasLayout = false, hasHeader, headerProps }: AuthRouteProps) => {
	const storage = new StorageManager();

	const { isAuth } = useAuthContext();
	const user = storage.getItem<User>('user');

	if (isAuth && user) {
		const path = user?.ENTRARCOMO === UserType.ALUNO ? ROUTES.selectModule : ROUTES.professorSelectPerlet;
		return <Navigate to={path} replace />;
	}

	return hasLayout ? <DefaultLayout {...{ hasHeader, headerProps }}>{children}</DefaultLayout> : children;
};

const noProtectRoutes: RoutesProps[] = [
	{
		path: ROUTES.login,
		element: <Login />,
		hasLayout: false,
	},
	{
		path: ROUTES.register,
		element: <h1>Cadastro</h1>,
		hasLayout: false,
	},
	{
		path: ROUTES.loginSSO,
		element: <LoginSSO />,
		hasLayout: false,
	},
];

export { NoAuthRoute, noProtectRoutes };
